import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Form, Input, FormInstance } from 'antd';
import { FILTER_CONDITIONS } from '@bringg/types';

import { FilterContentSelect } from './filter-content-select';
import { Translations } from '../filter-bar-2';

interface Props {
	name: string;
	translations: Translations;
	form: FormInstance;
	minValue: number;
	onFilterChange: () => void;
}

export const FilterContentNumberCondition = ({ name, translations, form, onFilterChange, minValue }: Props) => {
	const CONDITIONS = useMemo(() => {
		return Object.entries(translations.conditionFilter.options).reduce((acc, [key, value]) => {
			if (FILTER_CONDITIONS[key]) {
				acc.push({
					label: value,
					value: key
				});
			}
			return acc;
		}, []);
	}, [translations]);

	// TODO: should be done by Form.useWatch from next version of Antd pkg
	const [conditionType, setConditionType] = useState<FILTER_CONDITIONS>();

	// TODO: should be done by Form.useWatch from next version of Antd pkg
	const handleConditionTypeChange = useCallback((value: FILTER_CONDITIONS) => {
		setConditionType(value);
		onFilterChange();
	}, []);

	useEffect(() => {
		const formItemValue = form.getFieldValue(name);
		if (
			// Conditions from below has different value type from others
			// value for BETWEEN is object
			// value for IS_EMPTY or IS_NOT_EMPTY is `null`
			formItemValue?.condition === FILTER_CONDITIONS.BETWEEN ||
			formItemValue?.condition === FILTER_CONDITIONS.IS_EMPTY ||
			formItemValue?.condition === FILTER_CONDITIONS.IS_NOT_EMPTY
		) {
			form.setFieldsValue({
				[name]: Object.assign(formItemValue, { value: null })
			});
		}
	}, [conditionType]);

	const getFilterValueInput = useCallback(() => {
		switch (conditionType) {
			case FILTER_CONDITIONS.IS_NOT_EMPTY:
			case FILTER_CONDITIONS.IS_EMPTY: {
				return null;
			}

			case FILTER_CONDITIONS.BETWEEN: {
				return (
					<Form.Item name={[name, 'value']} className="number-range">
						<Input.Group compact>
							<Form.Item name={[name, 'value', 'from']} required>
								<Input
									type="number"
									min={minValue}
									placeholder={translations.conditionFilter?.from}
									onChange={onFilterChange}
								/>
							</Form.Item>
							<Form.Item name={[name, 'value', 'to']} required>
								<Input
									type="number"
									min={minValue}
									placeholder={translations.conditionFilter?.to}
									onChange={onFilterChange}
								/>
							</Form.Item>
						</Input.Group>
					</Form.Item>
				);
			}

			default: {
				return (
					<Form.Item name={[name, 'value']}>
						<Input
							type="number"
							min={minValue}
							placeholder={translations.search}
							onChange={onFilterChange}
						/>
					</Form.Item>
				);
			}
		}
	}, [conditionType]);

	return (
		<Form.Item name={name}>
			<Input.Group className="condition-filter">
				<FilterContentSelect
					className="condition-filter-select"
					name={[name, 'condition']}
					values={CONDITIONS}
					placeholder={translations.conditionFilter.operatorSelectPlaceholder}
					multiselect={false}
					translations={translations}
					onChange={handleConditionTypeChange}
					form={form}
					allowClear={false}
				/>
				{getFilterValueInput()}
			</Input.Group>
		</Form.Item>
	);
};
